import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/emr-department";

export const pagingDepartment = (searchObject) => {
    const url = API_PATH + "/search-by-page";
    return axios.post(url, searchObject);
};

export const pagingDepartmentByUser = (searchObject) => {
    const url = API_PATH + "/search-page-by-user";
    return axios.post(url, searchObject);
};


export const saveDepartment = department => {
    const url = API_PATH + "/save";
    return axios.post(url, department);
}

export const getDepartmentById = departmentId =>{
    const url = API_PATH + "/getbyid/" + departmentId;
    return axios.get(url);
}

export const deleteDepartmentById = departmentId =>{
    const url = API_PATH + "/mark-delete/" + departmentId;
    return axios.delete(url);
}

export const syncDrug = () =>
    axios.post(API_PATH + "/sync-department-from-hr", {},{
        headers: {
            "Content-Type": "application/json"
        }
    });
